/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BasketsPostRequestServiceItemsInner from './BasketsPostRequestServiceItemsInner';

/**
 * The BasketsPostRequest model module.
 * @module model/BasketsPostRequest
 * @version 1.0.0
 */
class BasketsPostRequest {
    /**
     * Constructs a new <code>BasketsPostRequest</code>.
     * @alias module:model/BasketsPostRequest
     */
    constructor() { 
        
        BasketsPostRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BasketsPostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BasketsPostRequest} obj Optional instance to populate.
     * @return {module:model/BasketsPostRequest} The populated <code>BasketsPostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BasketsPostRequest();

            if (data.hasOwnProperty('channel')) {
                obj['channel'] = ApiClient.convertToType(data['channel'], 'String');
            }
            if (data.hasOwnProperty('serviceItems')) {
                obj['serviceItems'] = ApiClient.convertToType(data['serviceItems'], [BasketsPostRequestServiceItemsInner]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BasketsPostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BasketsPostRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['channel'] && !(typeof data['channel'] === 'string' || data['channel'] instanceof String)) {
            throw new Error("Expected the field `channel` to be a primitive type in the JSON string but got " + data['channel']);
        }
        if (data['serviceItems']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['serviceItems'])) {
                throw new Error("Expected the field `serviceItems` to be an array in the JSON data but got " + data['serviceItems']);
            }
            // validate the optional field `serviceItems` (array)
            for (const item of data['serviceItems']) {
                BasketsPostRequestServiceItemsInner.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * Source of the basket creation (e.g., CUSTOMER-PORTAL)
 * @member {String} channel
 */
BasketsPostRequest.prototype['channel'] = undefined;

/**
 * @member {Array.<module:model/BasketsPostRequestServiceItemsInner>} serviceItems
 */
BasketsPostRequest.prototype['serviceItems'] = undefined;






export default BasketsPostRequest;

